'use client'

import { Common, HttpService, Messages, RingBuilder, ServiceEndpoints } from '@/config/NextImport'
import { setRingBuilderReady } from '@/lib/features/ringBuilderSlice'
import { AppDispatch, AppState } from '@/lib/store'
import { usePathname, useRouter } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'
import Cookies from 'js-cookie'

const BackLinkSection = (props: any) => {
  const pathname = usePathname()
  const router = useRouter()
  const dispatch = useDispatch<AppDispatch>()
  const { isRingBuilderReady } = useSelector((state: AppState) => state.ringBuilder)

  const BackToListing = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault()
    const storageSteps: any = RingBuilder.getRingBuilder()
    const settingUrl = storageSteps.filter((x: { step: string }) => x.step === 'setting')[0]
      .recent_url
    if (!Common.isNullorEmpty(settingUrl)) {
      router.replace(settingUrl)
    } else {
      router.replace(Common.getSanitizedUrl(pathname))
    }
  }

  const startNewFlow = async () => {
    const storageSteps: any = RingBuilder.getRingBuilder()
    RingBuilder.removeRingBuilder()
    const ringKey = RingBuilder.getRingBuilderKey()
    localStorage.removeItem(ringKey + '_id')
    let param = {}
    if (storageSteps[0].step === 'diamond') {
      param = {
        is_diamond: 1,
        is_gemstone: storageSteps[0].IsGemstone,
        settingType: sessionStorage.getItem(Messages.SettingType)
      }
    } else {
      param = {
        is_diamond: 0,
        settingType: sessionStorage.getItem(Messages.SettingType)
      }
    }
    const response = await HttpService.postApi(ServiceEndpoints.getDefaultUrl, param)
    sessionStorage.setItem('settingListScrollY', String(0))
    router.push(Common.getSanitizedUrl(response.result))
    dispatch(setRingBuilderReady(!isRingBuilderReady))
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="back-link-section d-flex justify-content-between align-items-center mb-2">
            <span className={props.category?.is_gift_card ? 'd-none' : 'back-link cursor'}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#505050"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-chevron-left"
              >
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
              <u onClick={(e) => BackToListing(e)}>Back To Collection</u>
            </span>

            {(props.category?.is_mto_category === 0 ||
              props.category?.is_mto_category === null) && (
              <span
                className="back-link cursor"
                onClick={(e) => startNewFlow()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#505050"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-chevron-left"
                >
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
                <u>Start Over</u>
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default BackLinkSection
